import { render } from "./CadastroCliente.vue?vue&type=template&id=d218c7a8"
import script from "./CadastroCliente.vue?vue&type=script&lang=ts"
export * from "./CadastroCliente.vue?vue&type=script&lang=ts"
script.render = render

export default script